import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface IProps {
    children?: ReactNode;
    className?: string;
    desktop?: "contents" | "plain";
    stacked?: boolean;
}

export const ModalFloatingActions = (props: IProps) => {
    const {children, className, desktop = "contents", stacked} = props;

    return (
        <div className={floatingShelfStyle}>
            <div
                className={cx(floatingActionsStyle, className)}
                data-desktop={desktop === "plain" ? "plain" : undefined}
                data-stacked={stacked ? "" : undefined}
            >
                {children}
            </div>
        </div>
    );
};

const floatingShelfStyle = css({
    backgroundColor: "var(--colors-white)",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    flexShrink: 0,
    mt: "-3.2rem",
    pb: 1,
    position: "relative",
    px: 1,
    zIndex: "var(--zIndex-base)",

    md: {
        backgroundColor: "transparent",
        borderRadius: 0,
        display: "contents",
        mt: 0,
        pb: 0,
        px: 0,
        zIndex: "auto"
    }
});

const floatingActionsStyle = css({
    alignItems: "center",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    boxShadow: "var(--shadow-4)",
    display: "flex",
    flexShrink: 0,
    height: "7.2rem",
    justifyContent: "center",
    minWidth: 0,
    position: "relative",
    px: 3,
    py: 1,
    width: "100%",
    zIndex: "var(--zIndex-base)",

    "& > button": {
        width: "100%"
    },

    "&[data-stacked]": {
        flexDirection: "column",
        gap: 1,
        height: "auto",
        pb: 1.5,
        pt: 1.5,

        md: {
            gap: 0,
            pb: 0,
            pt: 0
        }
    },

    md: {
        backgroundColor: "transparent",
        borderRadius: 0,
        boxShadow: "none",
        display: "contents",
        gap: 0,
        height: "auto",
        pb: 0,
        pt: 0,
        px: 0,
        py: 0,
        width: "auto",
        zIndex: "auto",

        "& > button": {
            minWidth: "20rem",
            width: "20rem"
        }
    },

    "&[data-desktop='plain']": {
        md: {
            display: "flex",
            mt: 2,
            p: 0,
            width: "100%",

            "& > button": {
                minWidth: "auto",
                width: "auto"
            }
        }
    }
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface IProps {
    children?: ReactNode;
    className?: string;
    desktop?: "contents" | "plain";
    stacked?: boolean;
}

export const ModalFloatingActions = (props: IProps) => {
    const {children, className, desktop = "contents", stacked} = props;

    return (
        <div className={floatingShelfStyle}>
            <div
                className={cx(floatingActionsStyle, className)}
                data-desktop={desktop === "plain" ? "plain" : undefined}
                data-stacked={stacked ? "" : undefined}
            >
                {children}
            </div>
        </div>
    );
};

const floatingShelfStyle = css({
    backgroundColor: "var(--colors-white)",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    flexShrink: 0,
    mt: "-3.2rem",
    pb: 1,
    position: "relative",
    px: 1,
    zIndex: "var(--zIndex-base)",

    md: {
        backgroundColor: "transparent",
        borderRadius: 0,
        display: "contents",
        mt: 0,
        pb: 0,
        px: 0,
        zIndex: "auto"
    }
});

const floatingActionsStyle = css({
    alignItems: "center",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    boxShadow: "var(--shadow-4)",
    display: "flex",
    flexShrink: 0,
    height: "7.2rem",
    justifyContent: "center",
    minWidth: 0,
    position: "relative",
    px: 3,
    py: 1,
    width: "100%",
    zIndex: "var(--zIndex-base)",

    "& > button": {
        width: "100%"
    },

    "&[data-stacked]": {
        flexDirection: "column",
        gap: 1,
        height: "auto",
        pb: 1.5,
        pt: 1.5,

        md: {
            gap: 0,
            pb: 0,
            pt: 0
        }
    },

    md: {
        backgroundColor: "transparent",
        borderRadius: 0,
        boxShadow: "none",
        display: "contents",
        gap: 0,
        height: "auto",
        pb: 0,
        pt: 0,
        px: 0,
        py: 0,
        width: "auto",
        zIndex: "auto",

        "& > button": {
            minWidth: "20rem",
            width: "20rem"
        }
    },

    "&[data-desktop='plain']": {
        md: {
            display: "flex",
            mt: 2,
            p: 0,
            width: "100%",

            "& > button": {
                minWidth: "auto",
                width: "auto"
            }
        }
    }
});
